import { render, staticRenderFns } from "./OccupyOrderExpend.vue?vue&type=template&id=45df3492&scoped=true&"
import script from "./OccupyOrderExpend.vue?vue&type=script&lang=js&"
export * from "./OccupyOrderExpend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df3492",
  null
  
)

export default component.exports